import React from 'react'
import "./Footer.css"

function Footer() {
    return (
        <footer className="Footer">
            <center>
                <p>
                    <a href="https://hessenapp.de/privacy-policy-2/" target="_blank"> Datenschutz</a> –
                    <a href="https://hessenapp.de/impressum/" target="_blank"> Impressum</a>
                </p>
                <p className="mb-0"><small>© 2024 Hessen App GmbH - Alle Rechte vorbehalten.</small></p>
            </center>
        </footer >

    )
}

export default Footer